import { REACT_HEADER_CLIENT_ID } from "../config/index";
import v4 from "uuid/v4";
import { slugify } from "transliteration";
import {
  getAntiforgeryToken,
  getAntiforgeryHeaderName,
} from "../utils/antiforgeryToken";

export const generalHeader = (token, rest) => {
  // Get BFF antiforgery token
  const afToken = getAntiforgeryToken();
  const afHeaderName = getAntiforgeryHeaderName();

  return {
    Accept: rest ? "application/json" : "application/vnd.api+json",
    "Content-Type": rest ? "application/json" : "application/vnd.api+json",
    "Client-Id": REACT_HEADER_CLIENT_ID,
    "Request-Id": v4(),
    ...(token ? { "X-CSRF-Token": token } : {}),
    ...(afToken ? { [afHeaderName]: afToken } : {}),
  };
};

export const uploadFileHeader = (token, fileName) => {
  // Get BFF antiforgery token
  const afToken = getAntiforgeryToken();
  const afHeaderName = getAntiforgeryHeaderName();

  return {
    Accept: "application/json",
    "Content-Type": "application/octet-stream",
    "Client-Id": REACT_HEADER_CLIENT_ID,
    "Request-Id": v4(),
    ...(token ? { "X-CSRF-Token": token } : {}),
    ...(afToken ? { [afHeaderName]: afToken } : {}),
    "Content-Disposition": `file; filename="${slugify(fileName)}"`,
  };
};
